import { ControlGroup, Checkbox } from "@blueprintjs/core";
import React from "react";
import { sprintf } from 'sprintf-js';

import { iDef } from "core/util/TypeUtils";
import BaseWidget from "./BaseWidget";
import ColorPickerWidget from "./ColorPickerWidget";
import CssUnitWidget from "./CssUnitWidget";

interface IBoxShadow {
	horizontal: string;
	vertical: string;
	blur: string;
	spread: string;
	color: string;
	inset: boolean;
}

export default class BoxShadowWidget extends BaseWidget<IBoxShadow, string> {

	public render() {
		const boxShadow = this.fromValue(this.props.value);

		return (
			<ControlGroup fill={true} vertical={true}>
				<CssUnitWidget
					value={boxShadow.horizontal}
					onChange={(value) => this.onChange(boxShadow, value, "horizontal")}
					readonly={false}
					autofocus={false}
					options={undefined}
				/>
				<CssUnitWidget
					value={boxShadow.vertical}
					onChange={(value) => this.onChange(boxShadow, value, "vertical")}
					readonly={false}
					autofocus={false}
					options={undefined}
				/>
				<CssUnitWidget
					value={boxShadow.blur}
					onChange={(value) => this.onChange(boxShadow, value, "blur")}
					readonly={false}
					autofocus={false}
					options={undefined}
				/>
				<CssUnitWidget
					value={boxShadow.spread}
					onChange={(value) => this.onChange(boxShadow, value, "spread")}
					readonly={false}
					autofocus={false}
					options={undefined}
				/>
				<ColorPickerWidget
					value={boxShadow.color}
					onChange={(value) => this.onChange(boxShadow, value, "color")}
					readonly={false}
					autofocus={false}
					options={undefined}
				/>
				<Checkbox checked={boxShadow.inset} onChange={(e: any) => this.onChange(boxShadow, e.target.checked, "inset")} /> 
			</ControlGroup>
		);
	}

	protected onChange(boxShadow: IBoxShadow, value: string, part: string) {
		const newBoxShadow = {...boxShadow, [part]: value};
		this.props.onChange(this.toValue(newBoxShadow));
	}

	protected toValue(boxShadow: IBoxShadow): string {
		const nextValue = sprintf(
			"%s%s %s %s %s %s",
			boxShadow.inset ? "inset " : "",
			boxShadow.horizontal,
			boxShadow.vertical,
			boxShadow.blur,
			boxShadow.spread,
			boxShadow.color
		);
		return nextValue;
	}

	protected fromValue(value: string): IBoxShadow {
		const parts = (iDef(value) ? value : "0px 0px 0px 0px rgba(0,0,0,0)").split(" ");
		const i = value && value.includes("inset") ? 1 : 0;

		const shadow: IBoxShadow = {
			inset: i > 0,
			horizontal: parts[i+0],
			vertical: parts[i+1],
			blur: parts[i+2],
			spread: parts[i+3],
			color: parts.slice(i+4).join(" ")
		};

		return shadow;
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/BoxShadowWidget.tsx